/*
###################################################################
Fitinsur Open Insurance - Copyright 2019-2023 - All Rights Reserved
###################################################################
*/

import React from 'react';
import { PropTypes } from 'prop-types';
import styled from 'styled-components';

import './font/style.css';
import './png/style.css';

const propTypes = {
  name: PropTypes.string
};

const defaultProps = {
  name: ''
};

const Icon = ({ name, className, disabled, ...props }) => (
  <i 
  {...props}
  onMouseDown={(e) => {if(props.onMouseDown) props.onMouseDown(e);}}
  onClick={(e) => { if (props.onClick && !disabled) props.onClick(e); }}
  className={`icon-${name} ${className || ''}`}
  style={{ 
    cursor: disabled ? 'not-allowed' : 'pointer',
    opacity: disabled && '30%'
  }}
 />
  );

Icon.propTypes = propTypes;
Icon.defaultProps = defaultProps;

export default styled(Icon)``;